import { DeviceType } from '$lib/constants';
import type { Nullable } from '$lib/types/RoastLog';
import { BaseDevice } from '../base';

import { BZ3 as RoastData } from './roasts';

let counter = 0;
const burner: Nullable<number> = null;

const POWER: number[] = [];
for (let i = 0; i < 101; i += 5) {
  POWER.push(i);
}

class FakeDevice extends BaseDevice {
  type: DeviceType = DeviceType.RLUSB;

  protected async onConnect(): Promise<boolean> {
    return true;
  }

  protected onDisconnect(): void {}

  protected updateReadings(): void | Promise<void> {
    let reading = RoastData[counter];

    if (!reading) {
      reading = RoastData[0];
      counter = 0;
    }

    this.localReadings = [
      reading[0],
      this.tcSettings?.[1].active && reading[1] ? reading[1] : null,
      this.tcSettings?.[2].active && reading[2] ? reading[2] : null,
      this.tcSettings?.[3].active && reading[3] ? reading[3] : null
    ];

    // burner = reading[0] % 10;
    // if (burner > 100) {
    //   burner = 100;
    // }

    counter += 1;
  }
}

export default FakeDevice;
